export default __webpack_public_path__ + "static/media/antelope@2x.217f9c38.jpg";